import styled from "styled-components";
import {OptInWinHighlightLabelDefaultBox} from "./opt-in-win-highlight-label.default.box";

export const OptInWinHighlightLabelMRGreenBox = styled(OptInWinHighlightLabelDefaultBox)`
    font-size: 1.2rem;
    font-weight: 500;
`;